import apiClient from '../apiClient';
import { trackPromise } from 'react-promise-tracker';

// ==========================
// GETS
// ==========================

async function listShifts() {
    const { data } = await trackPromise(apiClient.get('/api/shift/getAll'));
    return data?.data ?? [];
}

async function listShiftsEnabled() {
    const { data } = await trackPromise(apiClient.get('/api/shift/getAllEnabled'));
    return data?.data ?? [];
}

async function getShiftById(id) {
    const { data } = await trackPromise(apiClient.get(`/api/shift/getById/${id}`));
    return data?.data ?? null;
}

// ==========================
// MUTATIONS
// ==========================

async function createShift(payload) {
    const { data } = await trackPromise(apiClient.post('/api/shift/add/', payload));
    return data;
}

async function createShiftExtra(payload) {
    const { data } = await trackPromise(apiClient.post('/api/shift-extra/add/', payload));
    return data;
}

async function updateShift(id, payload) {
    const { data } = await trackPromise(apiClient.put(`/api/shift/updateById/${id}`, payload));
    return data;
}

async function updateShiftExtra(id, payload) {
    const { data } = await trackPromise(apiClient.put(`/api/shift-extra/updateById/${id}`, payload));
    return data;
}

async function toggleShift(id) {
    const { data } = await trackPromise(apiClient.put(`/api/shift/enabledDisable/${id}`));
    return data;
}

// ==========================
// EXPORT
// ==========================

const shiftService = {
    listShifts,
    getShiftById,
    createShift,
    createShiftExtra,
    updateShift,
    updateShiftExtra,
    toggleShift,
    listShiftsEnabled
};

export default shiftService;
